import type { Root } from 'mdast'
import { visit } from 'unist-util-visit'
import processCard from './Shortcodes/Card'
import processCodeBlock from './Shortcodes/CodeBlock'
import processEmailCard from './Shortcodes/EmailCard'
import processImage from './Shortcodes/Image'
import processMagicLink from './Shortcodes/MagicLink'
import processNotice from './Shortcodes/Notice'
import processPageHeadingList from './Shortcodes/PageHeadingList'
import processPhoneCard from './Shortcodes/PhoneCard'
import processSectionHeadingList from './Shortcodes/SectionHeadingList'
import processColumn from './Shortcodes/Column'
import processDownloadLink from './Shortcodes/DownloadLink'

/**
 * Plugin to support custom shortcodes(aka directives)
 *
 * @type {import('unified').Plugin<void[], Root>}
 */
const shortcodePlugin: import('unified').Plugin<[], Root> = function() {
  return (tree, file) => {
    visit(
      tree,
      (node, index, parent) => {
        if ('name' in node && typeof index === 'number' && parent) {
          if (node.type === 'containerDirective' || node.type === 'leafDirective' || node.type === 'textDirective') {
            switch (node.name) {
              case 'card':
                processCard(node)
                break
              case 'code-block':
                processCodeBlock(node)
                break
              case 'email-card':
                processEmailCard(node, file)
                break
              case 'notice':
                processNotice(node, file)
                break
              case 'phone-card':
                processPhoneCard(node, file)
                break
              case 'section-heading-list':
                processSectionHeadingList(node)
                break
              case 'columns':
                processColumn(node)
                break
              case 'download-link':
                processDownloadLink(node, index, parent, file)
                break
              case 'page-heading-list':
                processPageHeadingList(node, index, parent)
                break
              case 'magic-link':
                processMagicLink(node, index, parent, file)
                break
              case 'image':
                processImage(node, index, parent, file)
                break;
              default:
            }
          }
        }
      })
  }
}

export default shortcodePlugin